import { Injector } from "@angular/core";

export class Section {
    ioc: Injector;

    constructor (protected injector: Injector){
        this.ioc = injector;
    };

    resetSection() {
    };    

}